import React, { useState, useEffect } from 'react';
import axios from "axios"
import { FormControl, InputLabel, Input, FormHelperText } from '@material-ui/core';

import { Formik } from 'formik';

import { MainClientEdit, FormClientData } from './ClientEdit.Style';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

export default function ClientEdit (props) {
  const [ user, setUser ] = useState({})

  useEffect(()=>{
    let userSigned = JSON.parse(localStorage.getItem('token'));
    let tokenSigned = userSigned.token;
    let config =  { 
      headers : {
        'Content-Type' : 'application/json',
        'Accept' : 'application/json',
        'Authorization' : 'bearer ' + JSON.parse(localStorage.getItem('token'))
      }
    };

    axios.get(
      // `http://localhost:3000/admin/${props.match.params.id}`,
      `https://blooming-spire-64013.herokuapp.com/admin/${props.match.params.id}`,
      config,
      { withCredentials : true } )
      .then( success => {
        setUser(success.data)
      })
      .catch( error => {
        console.log(error)
      })
  },[])
  
  const handleFormChange = (e) => {
    let dataUser = user;
    dataUser[e.target.name] = e.target.value
    // setUser({user: dataUser})
  }

  let createNotification = (type, message="") => {
    return () => {
      switch (type) {
        case 'info':
          NotificationManager.info(message);
          break;
        case 'success':
          NotificationManager.success('Success message', 'Title here');
          break;
        case 'warning':
          NotificationManager.warning('Warning message', 'Close after 3000ms', 3000);
          break;
        case 'error':
          NotificationManager.error('Error message', 'Click me!', 5000, () => {
            alert('callback');
          });
          break;
        default: break;
      }
    };
  };

  const sendDataToServer = (e) => {
    e.preventDefault();
    createNotification('info', `Usuario actualizado.`)
    let config =  { 
      headers : {
        'Content-Type' : 'application/json',
        'Accept' : 'application/json',
        'Authorization' : 'bearer ' + JSON.parse(localStorage.getItem('token'))
      }
    };

    axios.put(`http://localhost:3000/users/${props.match.params.id}`, user, config, { withCredentials : true } )
      .then( success => createNotification('info', `Usuario ${success.data.firstName} actualizado.`) )
      .catch( error => console.log(error) )
  }

  let userStorage = JSON.parse(localStorage.getItem('user'))

  
  return (
    <MainClientEdit>
      <FormClientData onSubmit={sendDataToServer}>
      <NotificationContainer />
        <h2 style={{width: "100%"}}>Bienvenido {user.firstName ? user.firstName : ""}</h2>
        
        <p>Nombre(s):</p>
        <input onChange={handleFormChange} type="text" name="firstName" placeholder={user.firstName ? user.firstName : "No hay dato"}/>
        
        <p>Apellidos:</p>
        <input onChange={handleFormChange} type="text" name="lastName" placeholder={user.lastName ? user.lastName : "No hay dato"}/>
        
        <p>Correo Electronico:</p>
        <input onChange={handleFormChange} type="email" name="email" placeholder={user.email ? user.email : "No hay dato"}/>
        <p>Rol que tienes asignado:</p>
        {user.role ? <p>Tienes rol de: {user.role}</p> : <p>No tienes rol asignado</p> }
        <p>Nombre de la Empresa:</p>
        {user.nombreEmpresa ? <p>La empresa se llama: {user.nombreEmpresa}</p> : <p>La empresa no tiene nombre</p> }
        <p>Canal de Venta:</p>
        {user.principalCanalVenta ? <p>Canal de venta: {user.principalCanalVenta}</p> 
        :
        <select onChange={handleFormChange} name="principalCanalVenta">
          <option>Elige una opción</option>
          <option value="e-commerce">E-commerce</option>
          <option value="localfisico">Local físico</option>
          <option value="mayorista">Mayorista</option>
          <option value="otro">Otro...</option>
        </select>
        }
        <p>Sector al que pertenece la empresa:</p>
        {user.sector ? <p>Canal de venta: {user.sector}</p> 
        :
        <select onChange={handleFormChange} name="sector">
          <option>Elige una opción</option>
          <option value="financieroobancario">Financiero o Bancario</option>
          <option value="retail">Retail</option>
          <option value="tecnologia">Tecnología</option>
          <option value="otro">Otro...</option>
        </select>
        }
        <p>Giro al que pertenece la empresa:</p>
        {user.giroEmpresa ? <p>Giro de la empresa: {user.giroEmpresa}</p> 
        :
        <select onChange={handleFormChange} name="giroEmpresa">
          <option>Elige una opción</option>
          <option value="ropa">Ropa</option>
          <option value="alimentos">Alimentos</option>
          <option value="armamento">Armamento</option>
          <option value="otro">Otro...</option>
        </select>
        }
        <p>Facturación Anual Promedio:</p>
        {user.facturacionAnualPromedio ? <p>Facturación Anual de: {user.facturacionAnualPromedio}</p>
        :
        <select onChange={handleFormChange} name="facturacionAnualPromedio">
          <option>Elige una opción</option>
          <option value="menosde1millon"> menos de 1 millón</option>
          <option value="entre1y10millones">entre 1 y 10 millones</option>
          <option value="entre10y20millones">entre 10 y 20 millones</option>
          <option value="20millones">mas de 20 millones</option>
        </select>
        }
        <p>Años de Operación:</p>
        {user.añosOperacion ? <p>Años Operando: {user.añosOperacion}</p> : <p>No hay dato</p> }
        <p>Telefono:</p>
        {user.telefono ? <p>{user.telefono}</p> : <p>No hay dato</p> }
        <p>Regiones Sevir:</p>
        {user.regionesSevir ? <p>Region: {user.regionesSevir}</p>
        :
        <select onChange={handleFormChange} name="regionesSevir">
          <option>Elige una opción</option>
          <option value="nacional">nacional</option>
          <option value="local">local</option>
          <option value="internacional">internacional</option>
        </select>
      }
      <button type="submit">Actualizar</button>

      </FormClientData>

    </MainClientEdit>
  );
}